<script lang="ts">
	import { Splide, SplideSlide } from '@splidejs/svelte-splide'
	import { PUBLIC_BIXOTO_MEDIA } from '$env/static/public'
	import { t } from 'svelte-i18n-lingui'
	import { onMount, onDestroy } from 'svelte'
	import type { GalleryEntry } from '$lib/js/elasticsearch/types'
	import '@splidejs/splide/dist/css/themes/splide-default.min.css'
	import '$lib/css/components/splide.scss'

	export let productImages: GalleryEntry[] = []
	export let showImg = false
	export let imgIndex = 0

	let numImages = productImages.length
	let options = {
		type: 'loop',
		pagination: false,
		perPage: 1,
		perMove: 1,
		start: imgIndex,
		easing: 'cubic-bezier(0.37, 0, 0.63, 1)',
	}

	function closeModal(e: any) {
		if (
			e?.target?.id &&
			(e?.target.id === 'modal-bg' || e?.target.id === 'close-btn' || e?.target.id === 'close-span')
		) {
			showImg = false
		}
	}

	// Handle back actions using popstate
	function handlePopState(e: any) {
		closeModal(e)
	}

	// Set up event listener on mount and remove on destroy
	onMount(() => {
		// Add a state entry to allow back actions to be detected
		history.pushState(null, '', window.location.href)
		window.addEventListener('popstate', handlePopState)
	})

	onDestroy(() => {
		if (typeof window != 'undefined') {
			window.removeEventListener('popstate', handlePopState)
		}
	})
</script>

<div
	id="modal-bg"
	class="img-modal"
	onclick={(e) => closeModal(e)}
	role="dialog"
	aria-modal="true"
	tabindex="0"
	onkeydown={(e) => (e.key === 'Escape' ? closeModal(e) : null)}
>
	<div class="img-modal__inner">
		<button id="close-btn" class="close" onclick={(e) => closeModal(e)} aria-label="Close modal">
			<span id="close-span"></span>
		</button>

		<div class="img-modal__wrapper">
			{#if numImages > 1}
				<Splide {options} aria-label="Images slider" class="splide--modal">
					{#each productImages as image}
						<SplideSlide>
							{#if !image.vid}
								<img
									src="{PUBLIC_BIXOTO_MEDIA}{image.image}"
									alt={$t`Main Slider`}
									title={$t`Main Slider`}
								/>
							{/if}
						</SplideSlide>
					{/each}
				</Splide>
			{:else}
				<img
					src="{PUBLIC_BIXOTO_MEDIA}{productImages[0].image}"
					alt={$t`Main Slider`}
					title={$t`Main Slider`}
				/>
			{/if}
		</div>
	</div>
</div>

<style lang="scss">
	img {
		max-height: calc(100vh - 300px);
		object-fit: contain;
		border-radius: 8px;
		transition: all linear 0.125s;

		@media (max-width: 1024px) {
			width: 100%;
		}

		@media (min-width: 1025px) {
			max-width: calc(100vh - 200px);
		}
	}

	.img-modal {
		z-index: 99;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.8);
		display: flex;
		justify-content: center;
		align-items: center;

		&:hover {
			cursor: default;
		}

		button.close {
			position: absolute;
			top: -80px;
			right: 20px;
			background: transparent;
			border: 1px solid white;
			width: 60px;
			height: 60px;
			border-radius: 60px;
			display: flex;
			justify-content: center;
			align-items: center;

			@media (min-width: 769px) {
				top: 40px;
			}

			&:hover {
				cursor: pointer;
				background: var(--main);
				border-color: var(--main);
			}

			span {
				position: relative;
				width: 30px;
				height: 30px;

				&::before,
				&::after {
					position: absolute;
					content: '';
					width: 30px;
					height: 2px;
					background: white;
					transform-origin: center;
					top: 50%;
					left: calc(50% - 15px);
				}

				&::before {
					transform: rotate(45deg);
				}

				&::after {
					transform: rotate(-45deg);
				}
			}
		}

		&__wrapper {
			width: 100%;
			text-align: center;
		}

		&__inner {
			display: flex;
			justify-content: center;
			align-items: center;
			width: calc(100% - 80px);
			max-height: calc(100vh - 300px);
			padding: 20px;
			background: white;
			border-radius: 15px;

			@media (max-width: 768px) {
				position: relative;
			}

			@media (min-width: 769px) {
				max-width: 70%;
			}
		}
	}
</style>
